import React from 'react'
import './Services.css'
import {FiCheck} from 'react-icons/fi'
const Services = () => {
  return (
    <section id='services'>
      <h5>What  I Offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>Research and Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Access to resouces, funding and grants</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Collaboration opportunities</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Access to datasets and research facilities</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Constant mentorship and guidance</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Publication and presentation support</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Networking and communication opportunities</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Software Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Custom Software Development</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Web and Mobile Application Development</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>API Development and Integration</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Cloud Solutions</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Maintenance and Support</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>UI/UX Design</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Data Analytics and AI Integration</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Machine Learning and AI</h3>
          </div>

          <ul className="service__list">
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Data Analysis, Interpretation and Insights</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Custom Model Development and Deployment</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Natural Language Processing (NLP) and Computer Vision</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Automation and Optimization</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>AI Integration, Consultancy and Strategy</p>
            </li>
            <li>
              <FiCheck className='service__list-icon'/>
              <p>Predictive Analysis</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services